export default {"src":"/_next/static/media/clock_40.6fcfb35d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};